
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContextMessageAuthor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageUserBasicFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageUserAvatar"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useAvatar"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageUserRank"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useAuthorRank"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageAuthorDetails"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useHoverCard"}}}]}]}]}}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("./ContextMessageUserBasicFields.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ContextMessageUserAvatar.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ContextMessageUserRank.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ContextMessageAuthorDetails.fragment.graphql").definitions));


    module.exports = doc
  
